import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { Client } from '../../../../shared/client/client'
import { ListLigneCommande } from '../../../shared/commande'

export interface DialogData {
  lod_ligne_commandes: ListLigneCommande[]
  commandeId: string
  currentClient: Client
}

@Component({
  selector: 'app-besoin-dispatch-validate-dialog',
  templateUrl: './besoin-dispatch-validate-dialog.component.html',
  styleUrls: ['./besoin-dispatch-validate-dialog.component.scss']
})
export class BesoinDispatchValidateDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<BesoinDispatchValidateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: DialogData
  ) { }

  validate() {
    this.dialogRef.close(true)
  }

  refuse(): void {
    this.dialogRef.close(false)
  }
}